<template>
<nav id="main-nav">
         <ul class="second-nav">
            <li class="osahan-user-profile bg-primary">
               <div class="d-flex align-items-center gap-2">
                  <img src="img/delivery-boy.jpg" alt="" class="rounded-pill img-fluid">
                  <div class="ps-1">
                     <h5 class="fw-bold text-white osahan-mb-1">{{ profile.name }}</h5>
                     <p class="text-white-50 m-0">{{ profile.mobile }}</p>
                  </div>
               </div>
            </li>
            <!--<li><router-link :to="'/'"><i class="bi bi-house me-3"></i>Homepage</router-link></li>-->
            <!--<li><router-link :to="'/categorylist'"><i class="bi bi-house me-3"></i>Listing</router-link></li>-->
            <!-- <li><a href="product-detail.html"><i class="bi bi-file-break me-3"></i>Product Detail</a></li> -->
            <!--<li><router-link :to="'/profile'"><i class="bi bi-basket me-3"></i>Cart</router-link></li>-->
            <!-- <li><a href="payment-option.html"><i class="bi bi-credit-card me-3"></i>Payment Option</a></li>
            <!--<li><a href="payment-details.html"><i class="bi bi-stopwatch me-3"></i>Payment Time</a></li> -->  
            <!--<li><a href="order-received.html"><i class="bi bi-check-circle me-3"></i>Order Received</a></li>-->
            <!-- <li><a href="track-order.html"><i class="bi bi-truck me-3"></i>Track Order</a></li>
            <!--<li><a href="track-delivery-boy.html"><i class="bi bi-person-vcard me-3"></i>Track Delivery Boy</a></li> -- >
            <!--<li><router-link :to="'/profile'"><i class="bi bi-person me-3"></i>Profile</router-link></li>-->
            <!--<li><router-link :to="'/profile'"><i class="bi bi-receipt me-3"></i>Order Details</router-link></li>-->
            <!-- <li>
               <a href="#"><i class='bi bi-link me-3'></i>Example Multi Link</a>
               <ul>
                  <li><a href="#">Link</a></li>
                  <li><a href="#">Link</a></li>
               </ul>
            </li> -->
         </ul>
         <ul class="bottom-nav">
            <li class="home">
               <a href="index.html" class="text-primary">
                  <p class="h5 m-0"><i class="bi bi-house"></i></p>
                  Home
               </a>
            </li>
            <li class="cart">
               <router-link :to="'/profile'">
                  <p class="h5 m-0"><i class="bi bi-basket"></i></p>
                  Cart
               </router-link>
            </li>
            <li class="profile">
               <router-link :to="'/profile'">
                  <p class="h5 m-0"><i class="bi bi-person"></i></p>
                  Profile
               </router-link>
            </li>
         </ul>
      </nav>
</template>

  
<script> 
   import axios from "@/plugins/axios";  
   
   export default {
     name: 'sidebar',
     components: { 
     },
     mounted() {

       this.getHomeBasic(); // Call the method here
   },
     data() {
       return {
         loading:false,
         error:null,
         profile:[],   
       }
     },
     methods:{
       initializeHomeContent(){

       // this.getHomeBasic();
       },
   

       async getHomeBasic() {
           this.loading = true;
           this.error = null;
     
           try {
              var self=this;
               axios.post("getsidebarview").then((response) => {
               self.profile = response.data.profile;

           
             }).then(() => {
                  self.initializeHomeContent();
             }).catch((err) => {
               
             });;
            
   
           } catch (err) {
             this.error = err.response?.data?.message || "Login failed. Please try again.";
           } finally {
             this.loading = false;
           }
         }, 
     }
   }
   </script>
   